import { memo } from 'react';
import styled from '@emotion/styled';

import GalleryItem from './GalleryItem';

import type { ThemeProps } from '@emotion/react';
import type { CSSObject } from '@emotion/styled';

import type { Wws_PhotoGalleryItem } from '../../types/graphql';

const GalleryWrap = styled('div')`
  display: flex;
  margin: 24px auto 80px auto;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-self: center;
  max-width: 1000px;

  & > * {
    text-align: center;
  }

  ${(props: ThemeProps): CSSObject | undefined =>
    props.theme.components.PhotoGallery}
`;
export interface PhotoGalleryItemProps {
  item: Wws_PhotoGalleryItem;
  className?: string | undefined;
}

function PhotoGalleryItem({ item, className }: PhotoGalleryItemProps) {
  return (
    <GalleryWrap
      className={className}
      data-testid={`photo-gallery-item-${item.id}`}
    >
      {item.photoItems.map((photo, index, arr) => {
        return (
          <GalleryItem
            key={photo.id}
            photo={photo}
            index={index}
            photoItems={arr}
          />
        );
      })}
    </GalleryWrap>
  );
}

export default memo(PhotoGalleryItem);
